import {it} from "vuetify/locale";

export const tags = {
    namespaced: true,
    state: () => ({
        tags: [],
    }),
    mutations: {
        SET_TAGS: (state, payload) => {
            state.tags = payload
        },
        REMOVE_TAG: (state, payload) => {
            let itemIndex = state.tags.findIndex(item => item.id === payload?.id);
            if(itemIndex !== -1) {
                state.tags.splice(itemIndex, 1)
            }
        },
        ADD_TAG: (state, payload) => {
           let itemIndex = state.tags.findIndex(item => item.id === payload?.id);
           if(itemIndex !== -1) {
               state.tags[itemIndex] = payload
           } else {
               state.tags.unshift(payload)
           }
        }
    },
    actions: {
        FETCH_TAGS: (context, payload) => {
            context.commit('SET_TAGS', payload)
        },
        REMOVE_TAG: (context, payload) => {
            context.commit('REMOVE_TAG', payload)
        },
        ADD_TAG: (context, payload) => {
            context.commit('ADD_TAG', payload)
        }

    }
}